import { CheckCircleIcon } from "@heroicons/react/20/solid";
import React from "react";
import { connect } from "react-redux";
import Spinner from "../../common/Spinner";
import QuickbooksLogo from "./assets/quickbooks-icon.svg";
import { Actions as QUICKBOOKSACTIONS } from "./store/quickbooksActions";
import { useMemo } from "react";

const SendDataToQuickbooks = ({ periodId, sendPayPeriodToQuickbooks, sending, success, connected }) => {
	const status = useMemo(() => {
		if (sending)
			return (
				<Spinner
					style={{ color: "green", width: 12, position: "relative", top: -8, right: -14 }}
					className="animate-spin -ml-1 mr-3"
				/>
			);
		if (success)
			return (
				<CheckCircleIcon style={{ color: "green", width: 15, position: "relative", top: -8, right: -14 }} />
			);
	}, [connected, success, sending]);

	if (!connected || !status) return null;

	return (
		<div
			title="Send Data To QuickBooks"
			className="js-send-to-quickbooks"
			type="button"
			style={{
				height: "1.5em",
				width: "1.5em",
				borderRadius: "50%",
				position: "relative",
				cursor: "pointer",
				marginLeft: 10,
			}}
			onClick={() => {
				if (!sending) sendPayPeriodToQuickbooks(periodId);
			}}
		>
			<img
				src={QuickbooksLogo}
				style={{ width: 24.5 }}
			/>
			{status}
		</div>
	);
};

const mapStateToProps = (state, { periodId }) => {
	const { quickbooks } = { ...state.integration?.accounting };
	return {
		connected: quickbooks?.realmId,
		success: quickbooks?.payPeriods?.find((p) => p?.payPeriodId === periodId),
		sending: quickbooks?.sendingPayroll?.includes(periodId),
	};
};

const mapDispatchToProps = (dispatch) => ({
	sendPayPeriodToQuickbooks: (periodId) => dispatch(QUICKBOOKSACTIONS.sendPayPeriodToQuickbooks(periodId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SendDataToQuickbooks);
